export const MAX_ITEMS_PER_SECTION = 5;

export const ROW_TYPE = {
  SECTION_START: "section-start",
  SECTION_END: "section-end",
  ITEM: "item",
  SHOW_MORE: "show-more",
};
